(function () {
  function init(root) {
    if (!root || root.dataset.unistrutInit === "true") return;
    root.dataset.unistrutInit = "true";

    const FMAX = {
      P4000:  {250:428,500:214,750:142,1000:107,1250:85,1500:71,1750:61,2000:53},
      P2000:  {250:1250,500:625,750:416,1000:312,1250:250,1500:208,1750:178,2000:156,2250:138,2500:125,2750:113,3000:104},
      P3300:  {250:553,500:276,750:184,1000:138,1250:110,1500:92,1750:79,2000:69},
      P3301:  {250:1558,500:779,750:519,1000:389,1250:311,1500:259,1750:222,2000:194,2250:173,2500:155,2750:141,3000:129},
      P1000:  {250:1770,500:884,750:589,1000:442,1250:353,1500:294,1750:252,2000:221,2250:196,2500:176,2750:160,3000:147},
      P1001:  {750:1671,1000:1253,1250:1002,1500:835,1750:716,2000:626,2250:556,2500:501,2750:455,3000:417},
      P5500:  {750:1088,1000:816,1250:653,1500:544,1750:466,2000:408,2250:362,2500:326,2750:296,3000:272},
      P5000:  {750:1373,1000:1030,1250:824,1500:686,1750:588,2000:515,2250:457,2500:412,2750:374,3000:343},
      P5501T: {1500:1606,1750:1376,2000:1204,2250:1070,2500:966,2750:875,3000:802},
      P5001T: {1250:2502,1500:2085,1750:1787,2000:1564,2250:1389,2500:1250,2750:1137,3000:1042}
    };

    const FDEF = {
      P4000:  {250:0.46,500:1.85,750:4.16,1000:7.41,1250:11.57,1500:16.67,1750:22.69,2000:29.64},
      P2000:  {250:0.24,500:0.97,750:2.19,1000:3.91,1250:6.11,1500:8.79,1750:11.97,2000:15.64,2250:19.79,2500:24.44,2750:29.57,3000:35.19},
      P3300:  {250:0.45,500:1.81,750:4.07,1000:7.24,1250:11.32,1500:16.30,1750:22.19,2000:28.99},
      P3301:  {250:0.26,500:1.07,750:2.42,1000:4.30,1250:6.72,1500:9.68,1750:13.18,2000:17.21,2250:21.79,2500:26.90,2750:32.55,3000:38.73},
      P1000:  {250:0.23,500:0.95,750:2.15,1000:3.82,1250:5.97,1500:8.60,1750:11.70,2000:15.29,2250:19.35,2500:23.89,2750:28.91,3000:34.40},
      P1001:  {750:1.21,1000:2.15,1250:3.36,1500:4.84,1750:6.59,2000:8.61,2250:10.89,2500:13.45,2750:16.27,3000:19.37},
      P5500:  {750:1.40,1000:2.49,1250:3.89,1500:5.60,1750:7.63,2000:9.97,2250:12.62,2500:15.58,2750:18.85,3000:22.43},
      P5000:  {750:0.84,1000:1.49,1250:2.34,1500:3.37,1750:4.58,2000:5.99,2250:7.58,2500:9.36,2750:11.33,3000:13.48},
      P5501T: {1500:3.07,1750:4.18,2000:5.47,2250:6.92,2500:8.54,2750:10.34,3000:12.30},
      P5001T: {1250:1.25,1500:1.80,1750:2.45,2000:3.20,2250:4.05,2500:5.00,2750:6.05,3000:7.21}
    };

    const INFO = {
      P4000:  "Let montageskinne (41x21x1,5 mm)",
      P2000:  "Let montageskinne (41x41x1,5 mm)",
      P3300:  "Montageskinne (41x21x2,5 mm)",
      P3301:  "Dobbelt montageskinne (41x41x2,5 mm)",
      P1000:  "Montageskinne (41x41x2,5 mm)",
      P1001:  "Dobbelt montageskinne (41x83x2,5 mm)",
      P5500:  "Montageskinne (41x62x2,5 mm)",
      P5501T: "Dobbelt montageskinne (41x124x2,5 mm)",
      P5000:  "Montageskinne (41x83x2,5 mm)",
      P5001T: "Dobbelt montageskinne (41x165x2,5 mm)"
    };

    const profilesOrder = ["P4000","P2000","P3300","P3301","P1000","P1001","P5500","P5000","P5501T","P5001T"];

    const spanSelect    = root.querySelector("[data-unistrut-span]");
    const loadInput     = root.querySelector("[data-unistrut-load]");
    const resultDiv     = root.querySelector("[data-unistrut-result]");
    const btn           = root.querySelector("[data-unistrut-calc]");
    const modalBackdrop = root.querySelector("[data-unistrut-modal]");
    const modalOpenBtn  = root.querySelector("[data-unistrut-open]");
    const modalCloseBtn = root.querySelector("[data-unistrut-close]");

    if (!spanSelect || !loadInput || !resultDiv || !btn) return;

    function getMode(){
      const r = root.querySelector('input[name="unistrut-mode"]:checked');
      return r ? r.value : "Fmax";
    }

    function qualifiesProfile(profile, L, load, mode){
      if (!FMAX[profile] || FMAX[profile][L] == null) return false;
      const Fp = FMAX[profile][L];
      if (mode === "Fmax") return load <= Fp;

      if (!FDEF[profile] || FDEF[profile][L] == null) return false;
      const fp = FDEF[profile][L];
      if (load > Fp) return false;

      const denom = mode === "L200" ? 200 : 360;
      const limit = L / denom;
      const f_est = fp * (load / Fp);
      return f_est <= limit;
    }

    function classifyProfile(profile, L, load, mode){
      if (!FMAX[profile] || FMAX[profile][L] == null) return { qualifies:false };
      const Fp = FMAX[profile][L];

      if (mode === "Fmax") return load <= Fp ? { qualifies:true } : { qualifies:false };

      if (!FDEF[profile] || FDEF[profile][L] == null) return { qualifies:false };
      const fp = FDEF[profile][L];
      if (load > Fp) return { qualifies:false };

      const denom = mode === "L200" ? 200 : 360;
      const limit = L / denom;
      const f_est = fp * (load / Fp);
      if (f_est > limit) return { qualifies:false };

      return { qualifies:true, strict: fp <= limit, f_est, limit };
    }

    function baseDisplay(profile){
      return profile === "P4000" ? "P4000 (P3300)" : profile;
    }

    function addParen(text, add){
      if (text.includes(add)) return text;
      if (!text.includes("(")) return text + " (" + add + ")";
      const i = text.indexOf("(");
      const left = text.slice(0, i);
      const inside = text.slice(i + 1, -1).split(",").map(s => s.trim()).filter(Boolean);
      if (!inside.includes(add)) inside.push(add);
      return left + "(" + inside.join(", ") + ")";
    }

    function calculate(){
      const L = parseInt(spanSelect.value, 10);
      const load = parseFloat(loadInput.value);
      const mode = getMode();

      if (Number.isNaN(load) || load <= 0){
        resultDiv.innerHTML = "<span style='color:#b00020'>Angiv en gyldig jævn belastning i kg.</span>";
        return;
      }

      let chosen = null;
      let cls = null;

      for (const p of profilesOrder){
        const c = classifyProfile(p, L, load, mode);
        if (c.qualifies){
          chosen = p;
          cls = c;
          break;
        }
      }

      if (!chosen){
        resultDiv.innerHTML =
          "Ingen profiler matcher de valgte værdier.<br>" +
          "Prøv lavere last, kortere spændvidde eller et lempeligere krav." +
          "<div class='unistrut-note'>Bemærk: Beregningen er vejledende og baseret på lineær ekstrapolering af nedbøjning ved jævn belastning.</div>";
        return;
      }

      let name = baseDisplay(chosen);
      if (chosen !== "P1000" && qualifiesProfile("P1000", L, load, mode)){
        name = addParen(name, "P1000");
      }

      const info = INFO[chosen] || "";
      const mainLabel = info ? `${name} – ${info}` : name;

      const modeText = mode === "Fmax" ? "Ingen" : (mode === "L200" ? "L/200" : "L/360");

      let html = "";
      html += `<div class="unistrut-main-result">Anbefalet skinne: <span>${mainLabel}</span></div>`;
      html += `Spændvidde: <strong>${L} mm</strong><br>`;
      html += `Jævn belastning: <strong>${load} kg</strong><br>`;
      html += `Nedbøjningskrav: <strong>${modeText}</strong>`;

      if (mode !== "Fmax" && cls && cls.f_est != null){
        html += "<hr>";
        html += `Nedbøjning ved denne belastning: <strong>${cls.f_est.toFixed(2)} mm</strong><br>`;
        html += `Max tilladt: <strong>${cls.limit.toFixed(2)} mm</strong><br>`;
        html += (cls.strict ? "<strong>Striks OK</strong>" : "<span>OK ved valgt last</span>");
      }

      html += `
        <div class="unistrut-note">
          Bemærk: Beregningen er vejledende og baseret på lineær ekstrapolering af nedbøjning ved jævn belastning.
          Ved kritiske installationer, dynamiske laster, punktbelastninger eller komplekse ophæng anbefales altid en egentlig statisk kontrol.
        </div>
      `;

      resultDiv.innerHTML = html;
    }

    function openModal(){
      if (modalBackdrop) modalBackdrop.style.display = "flex";
    }
    function closeModal(){
      if (modalBackdrop) modalBackdrop.style.display = "none";
    }

    btn.addEventListener("click", calculate);
    loadInput.addEventListener("input", calculate);
    spanSelect.addEventListener("change", calculate);
    root.querySelectorAll('input[name="unistrut-mode"]').forEach(r => r.addEventListener("change", calculate));

    if (modalOpenBtn) modalOpenBtn.addEventListener("click", openModal);
    if (modalCloseBtn) modalCloseBtn.addEventListener("click", closeModal);
    if (modalBackdrop){
      modalBackdrop.addEventListener("click", function (e) {
        if (e.target === modalBackdrop) closeModal();
      });
    }

    calculate();
  }

  function scan() {
    document.querySelectorAll("[data-unistrut-root]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }

  // Hvis password-løsningen “indsætter” indhold efter unlock, fanger vi det her:
  const mo = new MutationObserver(scan);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
